var _path;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFaq(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "fill",
    width: 18,
    height: 22,
    viewBox: "0 0 386 462",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M385.82 173.25C385.815 168.247 384.036 163.319 380.346 159.639L225.946 5.63904C222.256 1.94665 217.317 0.1552 212.3 0.1552V0H96.5C43.2935 0 0 43.1814 0 96.25V365.75C0 418.819 43.2935 462 96.5 462H289.5C342.706 462 386 418.819 386 365.75V173.25H385.82ZM231.6 65.7207L320.109 154H289.5C257.572 154 231.6 128.096 231.6 96.25V65.7207ZM289.5 423.5H96.5C64.5718 423.5 38.6 397.596 38.6 365.75V96.25C38.6 64.4045 64.5718 38.5 96.5 38.5H193V96.25C193 149.319 236.294 192.5 289.5 192.5H347.4V365.75C347.4 397.596 321.428 423.5 289.5 423.5ZM289.5 346.5C289.5 357.14 280.858 365.75 270.2 365.75H115.8C105.142 365.75 96.5 357.14 96.5 346.5C96.5 335.86 105.142 327.25 115.8 327.25H270.2C280.858 327.25 289.5 335.86 289.5 346.5ZM289.5 269.5C289.5 280.14 280.858 288.75 270.2 288.75H115.8C105.142 288.75 96.5 280.14 96.5 269.5C96.5 258.86 105.142 250.25 115.8 250.25H270.2C280.858 250.25 289.5 258.86 289.5 269.5ZM96.5 192.5C96.5 181.86 105.142 173.25 115.8 173.25H154.4C165.058 173.25 173.7 181.86 173.7 192.5C173.7 203.14 165.058 211.75 154.4 211.75H115.8C105.142 211.75 96.5 203.14 96.5 192.5Z",
    fill: "#0B2640"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.843a0b9534593d35f21af8bdd68a2e81.svg";
export { ForwardRef as ReactComponent };